import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AsiCustomerDto } from '@myasi/api/myasi-auth/permissions/models/asi-customer-dto';
import { AsiUserDto } from '@myasi/api/myasi-auth/permissions/models/asi-user-dto';
import { AuthControllerService } from '@myasi/api/myasi-auth/permissions/services/auth-controller.service';

import { ErrorHandlingType } from '@svg-frontends/error/enums/error-handling-type.enum';
import { ErrorMessageKey } from '@svg-frontends/error/enums/error-message-key';
import { ErrorHandlingService } from '@svg-frontends/error/services/error-handling.service';

@Injectable({ providedIn: 'root' })
export class AuthRepositoryService {
	private authControllerService = inject(AuthControllerService);
	private errorHandlingService = inject(ErrorHandlingService);

	getUser(): Observable<AsiUserDto> {
		return this.authControllerService.getUserInfo().pipe(
			catchError((httpErrorResponse: HttpErrorResponse) => {
				const errorKey = this.getCustomerInfoEndpointErrorKey(httpErrorResponse);
				this.errorHandlingService.setNextErrorByKey(errorKey, ErrorHandlingType.ROUTE_TO_ERROR_PAGE, false);
				return of(null);
			}),
		);
	}

	getCustomer(customerId: string): Observable<AsiCustomerDto> {
		return this.authControllerService.getCustomerInfo({ id: customerId }).pipe(
			catchError((httpErrorResponse: HttpErrorResponse) => {
				const errorKey = this.getCustomerInfoEndpointErrorKey(httpErrorResponse);
				this.errorHandlingService.setNextErrorByKey(errorKey, ErrorHandlingType.ROUTE_TO_ERROR_PAGE, false);
				return of(null);
			}),
		);
	}

	private getCustomerInfoEndpointErrorKey(httpErrorResponse: HttpErrorResponse): string {
		if (httpErrorResponse.status === 404) {
			return ErrorMessageKey.AUTH_CUSTOMER_NOT_FOUND;
		} else if (httpErrorResponse.status === 403) {
			return ErrorMessageKey.AUTH_CUSTOMER_FORBIDDEN;
		} else {
			return httpErrorResponse.status.toString();
		}
	}
}
